import { render, staticRenderFns } from "./MBatchAiInteractions.vue?vue&type=template&id=0ebd6548&lang=pug&"
import script from "./MBatchAiInteractions.vue?vue&type=script&lang=js&"
export * from "./MBatchAiInteractions.vue?vue&type=script&lang=js&"
import style0 from "./MBatchAiInteractions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports